/**
 * Accordion Controller
 *
 * Handles accordion item expand/collapse functionality with smooth transitions
 */

import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["content", "icon", "question"];
  static values = {
    open: { type: Boolean, default: false },
  };

  connect() {
    // Set initial state
    if (!this.openValue) {
      this.close();
    } else {
      this.open();
    }
  }

  toggle(event) {
    // Prevent any default behavior
    event.preventDefault();

    // Toggle the open state
    this.openValue = !this.openValue;

    // Apply the appropriate state
    this.openValue ? this.open() : this.close();
  }

  open() {
    // Update content visibility
    if (this.hasContentTarget) {
      this.contentTarget.classList.remove("hidden");
    }

    // Rotate icon
    if (this.hasIconTarget) {
      this.iconTarget.classList.add("rotate-180");
    }

    // Update question color
    if (this.hasQuestionTarget) {
      this.questionTarget.classList.add("text-nr-green");
    }

    // Update aria-expanded
    const button = this.element.querySelector("button[aria-expanded]");
    if (button) {
      button.setAttribute("aria-expanded", "true");
    }

    // Dispatch custom event
    this.dispatch("opened");
  }

  close() {
    // Update content visibility
    if (this.hasContentTarget) {
      this.contentTarget.classList.add("hidden");
    }

    // Rotate icon back
    if (this.hasIconTarget) {
      this.iconTarget.classList.remove("rotate-180");
    }

    // Update question color
    if (this.hasQuestionTarget) {
      this.questionTarget.classList.remove("text-nr-green");
    }

    // Update aria-expanded
    const button = this.element.querySelector("button[aria-expanded]");
    if (button) {
      button.setAttribute("aria-expanded", "false");
    }

    // Dispatch custom event
    this.dispatch("closed");
  }

  // Called when openValue changes
  openValueChanged() {
    this.openValue ? this.open() : this.close();
  }
}
